import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DashboardLastOrderRes;
export const DashboardLastOrderTodo = createAsyncThunk('DashboardLastOrder', async (data) => {


    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_last_order',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcustomer_code": localStorage.getItem('vcust_plant_code')
            }
        })
        return DashboardLastOrderRes = res.data

    } catch (error) {
        return DashboardLastOrderRes = error.response.data
    }
});

const DashboardLastOrderSlice = createSlice({
    name: 'DashboardLastOrder',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DashboardLastOrderTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DashboardLastOrderTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DashboardLastOrderSlice.reducer; 